module.exports = __webpack_public_path__ + "static/media/negotiate.ba38de62.jpg";